import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { loadSettings } from "@/shared/config/settings";

const el = document.getElementById("app");

// App and tracking are imported only after settings load: modules under them
// read `settings` at module scope. Nothing they pull in may be imported
// statically here.
loadSettings()
  .then(() => Promise.all([import("./App"), import("./lib/tracking")]))
  .then(([{ default: App }, { initTracking }]) => {
    initTracking();
    if (el) {
      createRoot(el).render(
        <StrictMode>
          <App />
        </StrictMode>,
      );
    }
  })
  .catch((error: unknown) => {
    console.error("startup failed", error);
    if (el) {
      el.textContent = `Startup failed: ${error instanceof Error ? error.message : String(error)}`;
      el.style.cssText = "padding:2rem;font:14px monospace;color:#900;white-space:pre-wrap";
    }
  });
